import React, { createContext, PropsWithChildren, useContext, useEffect } from "react"
import { AuthActionTypes, Fields, useStateContext, useStateDispatcher } from "state"
import ManagementBackendClient from "services/management-backend/client"
import axios, { AxiosError, InternalAxiosRequestConfig } from "axios"

const instance = axios.create({
    headers: {
        Authorization: localStorage.getItem(Fields.TOKEN),
        'Content-Type': 'application/json',
    },
    baseURL: import.meta.env.VITE_MANAGEMENT_URL
});


const ClientContext = createContext({ management: new ManagementBackendClient(instance) });

const ClientProvider = ({ children }: PropsWithChildren) => {

    const dispatcher = useStateDispatcher();
    const state = useStateContext();


    useEffect(() => {
        const req = async (config: InternalAxiosRequestConfig): Promise<InternalAxiosRequestConfig> => {
            if (state.tokens) config.headers.Authorization = state.tokens.token
            return config
        }

        const error = (error: AxiosError) => {
            if (state.tokens && error.response?.status === 401) {
                dispatcher({ type: AuthActionTypes.LOGOUT })
            }
            return Promise.reject(error)
        }
        let interceptors = {
            response: instance.interceptors.response.use((res) => res, error),
            request: instance.interceptors.request.use(req, (error) => error)
        }
        return () => {
            instance.interceptors.response.eject(interceptors.response)
            instance.interceptors.request.eject(interceptors.request)
        }
    }, [state.tokens])

    return (
        <ClientContext.Provider value={{ management: new ManagementBackendClient(instance) }}>
            {children}
        </ClientContext.Provider>
    )
}

const useClientContext = () => {
    return useContext(ClientContext)
}

export { ClientContext, ClientProvider, useClientContext }
